import { render, staticRenderFns } from "./MobileOrderProduct.vue?vue&type=template&id=06be811d&"
import script from "./MobileOrderProduct.vue?vue&type=script&lang=js&"
export * from "./MobileOrderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports